<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <div>
        <vue-table
          v-model="selectedRow"
          :data="nfcList"
          :headers="headers"
          :loading.sync="loading"
          single-select
        >
          <template v-slot:helpinfo="{ tab }">
            <help-info
              v-if="tab && tab.value && tab.text"
              :element-name="`${serviceName}-${componentName}-${tab.value}`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              :label="`${tab.text}`"
            />
          </template>
          <template v-slot:filters="{ props, perPage }">
            <v-row no-gutters>
              <v-col class="pa-2" cols="12" lg="2" md="2">
                <div class="rowinfo">
                  <v-select
                    v-model="props.length"
                    :items="perPage"
                    class="rounded-lg"
                    dense
                    hide-details
                    :label="$t('count')"
                    outlined
                  />
                  <help-info
                    :element-name="`${serviceName}-${componentName}-props-length`"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                    :label="$t('count')"
                  />
                </div>
              </v-col>
              <v-col class="pa-2" cols="12" lg="4" md="6">
                <div class="rowinfo">
                  <v-text-field
                    v-model="props.search"
                    append-icon="mdi-magnify"
                    class="rounded-lg contentinfo"
                    clearable
                    dense
                    hide-details
                    :label="$t('search')"
                    outlined
                  />
                  <help-info
                    :element-name="`${serviceName}-${componentName}-props-search`"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                    :label="$t('search')"
                  />
                </div>
              </v-col>
            </v-row>
          </template>
        </vue-table>
      </div>
    </template>
  </help-info-wrapper>
</template>

<script>
export default {
  name: "index",

  data: () => ({
    helpData: [],
    serviceName: "Qrland",
    componentName: "index-nfc",
    headers: [
      { value: "index", text: this.$t('row'), sortable: false, align: "center" },
      { value: "id", text: this.$t('id'), sortable: false, align: "center" },
      { value: "picture", text: this.$t('images'), sortable: false, align: "center" },
      { value: "title", text: this.$t('title'), sortable: false, align: "center" },
      { value: "tag", text: this.$t('tags'), sortable: false, align: "center" },
      {
        value: "orientation",
        text: this.$t('print_type'),
        sortable: false,
        align: "center",
      },
      { value: "status", text: this.$t('status'), sortable: false, align: "center" },
      { value: "user-id", text: this.$t('user'), sortable: false, align: "center" },
      {
        value: "shipping-info",
        text: this.$t('user_shipping_info'),
        sortable: false,
        align: "center",
      },
      {
        value: "short-url",
        text: this.$t('qr_short_link'),
        sortable: false,
        align: "center",
      },
      { value: "color", text: this.$t('color'), sortable: false, align: "center" },
    ],
    nfcList: {},
    selectedRow: [],
    loading: false,
    tableProps: {
      page: 1,
      length: 10,
      search: "",
      color: "",
    },
  }),
};
</script>

<style scoped></style>
